<template>
	<transition name="fade">
		<div v-if="visible" class="toast flex align-center" :class="typeClass">
			<i class="el-icon-success" v-if="type=='success'"></i>
			<i class="el-icon-info" v-if="type=='info'"></i>
			<i class="el-icon-warning" v-if="type=='warning'"></i>
			<i class="el-icon-error" v-if="type=='error'"></i>
			<div>{{ message }}</div>
		</div>
	</transition>
</template>

<script>
	export default {
		data() {
			return {
				visible: false,
				message: '',
				type: 'info', // 可以是 info, success, warning, error
			};
		},
		computed: {
			typeClass() {
				return `toast-${this.type}`;
			}
		},
		methods: {
			show({message='', type='info',duration=3000}) {
				this.message = message;
				this.type = type;
				this.visible = true;
				setTimeout(() => {
					this.visible = false;
				}, duration); // 显示3秒后自动消失
			}
		}
	};
</script>

<style lang="scss" scoped>
	@media screen and (min-width: 1000px) {
		.toast {
			position: fixed;
			background-color: rgba(0, 0, 0, .8);
			top: 50%;
			left: 50%;
			max-width: 330px;
			min-width: 150px;
			transform: translate(-50%, -50%);
			padding: 10px 15px;
			border-radius: 5px;
			box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
			z-index: 10000;
			color: #fff;
			i{
				margin-right: 10px;
				font-size: 24px;
			}
		}
	}
	@media screen and (max-width: 999px){
		.toast {
			position: fixed;
			background-color: rgba(0, 0, 0, .8);
			top: 50%;
			left: 50%;
			max-width: 50vw;
			min-width: 40vw;
			transform: translate(-50%, -50%);
			padding: 2.666666vw 4vw;
			border-radius: 1.3333339vw;
			font-size: 3.73333vw;
			z-index: 10000;
			color: #fff;
			i{
				margin-right: 2.666666vw;
				font-size: 6.4vw;
			}
		}
	}

	.toast-info {
		i{
			color: #909399;
		}
	}

	.toast-success {
		i{
			color: #67c23a;
		}
	}

	.toast-warning {
		i{
			color: #e6a23c;
		}
	}

	.toast-error {
		i{
			color: #f56c6c;
		}
	}

	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.5s;
	}

	.fade-enter,
	.fade-leave-to

	/* .fade-leave-active in <2.1.8 */
		{
		opacity: 0;
	}
</style>